import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {firebaseConnect} from 'react-redux-firebase';
import { withTranslation } from "react-i18next";
import * as actionsAccountModal from '../../actions/accountModalActions';
import CaQuizToutView from "./CaQuizToutView";

class CaQuizToutContainer extends React.Component {

    constructor(props){
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const {linkCta} = this.props;
        window.location.href = "/quiz/golden-club-quiz/";
    }

    render(){

        //FIXME: REPLACE IMAGE!!!
        return(
            <CaQuizToutView
                header={this.props.t('quiz_tout.header')}
                title={this.props.t('quiz_tout.title')}
                description={this.props.t('quiz_tout.description')}
                image={"https://abbasite.com/uploads/2018/04/newsletter-image-1.jpg"}
                cta={this.props.t('take_quiz_cta')}
                ctaCallback={this.handleClick}
            />
        )
    }
}

function mapStateToProps(state) {
    return {
        state: state.firebase.auth,
        profile: state.firebase.profile,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actionsAccountModal: () => dispatch(actionsAccountModal())
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firebaseConnect(),
)(withTranslation("translations")(CaQuizToutContainer))
